/**
 * Converte definition_json (backend) ↔ modelo do editor visual.
 */

/** Normaliza ID digitado pelo usuário (minúsculas, espaços → _). */
export function normalizeStepId(raw) {
  return String(raw || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_')
}

/** Letra inicial + letras, números ou _ (máx. 64 caracteres). */
export function isValidStepId(id) {
  return /^[a-zA-Z][a-zA-Z0-9_]{0,63}$/.test(id)
}

/** Valor do select "Próximo passo" para handoff em nó message. */
export const HANDOFF_NEXT = '__handoff__'

export function definitionToEditor(definitionJson) {
  let parsed
  try {
    parsed = typeof definitionJson === 'string' ? JSON.parse(definitionJson) : definitionJson
  } catch {
    parsed = { version: 1, startNodeId: 'start', nodes: {} }
  }
  const nodes = parsed.nodes || {}
  const steps = Object.keys(nodes).map((id) => {
    const n = nodes[id]
    const isMenu = (n.type || 'menu').toLowerCase() === 'menu'
    const nextNodeId =
      !isMenu && n.action === 'handoff' ? HANDOFF_NEXT : (n.nextNodeId || '')
    return {
      id,
      type: isMenu ? 'menu' : 'message',
      text: n.text || '',
      nextNodeId,
      options: isMenu
        ? (n.options || []).map((o) => ({
            id: String(o.id || ''),
            label: o.label || '',
            action: o.action === 'handoff' ? 'handoff' : (o.nextNodeId ? 'goto' : 'end'),
            targetId: o.nextNodeId || ''
          }))
        : []
    }
  })
  return {
    startNodeId: parsed.startNodeId || (steps[0]?.id ?? 'start'),
    steps: steps.length ? steps : [defaultStartStep()]
  }
}

export function editorToDefinition(editor) {
  const nodes = {}
  for (const step of editor.steps || []) {
    if (step.type === 'message') {
      const node = { type: 'message', text: step.text || '' }
      if (step.nextNodeId === HANDOFF_NEXT) {
        node.action = 'handoff'
      } else if (step.nextNodeId) {
        node.nextNodeId = step.nextNodeId
      }
      nodes[step.id] = node
    } else {
      nodes[step.id] = {
        type: 'menu',
        text: step.text || '',
        options: (step.options || []).map((o) => {
          if (o.action === 'handoff') {
            return { id: String(o.id), label: o.label, action: 'handoff' }
          }
          if (o.action === 'end' || !o.targetId) {
            return { id: String(o.id), label: o.label, nextNodeId: '' }
          }
          return { id: String(o.id), label: o.label, nextNodeId: o.targetId }
        })
      }
    }
  }
  return JSON.stringify(
    {
      version: 1,
      startNodeId: editor.startNodeId || 'start',
      nodes
    },
    null,
    2
  )
}

export function defaultStartStep() {
  return {
    id: 'start',
    type: 'menu',
    text: 'Olá! Como podemos ajudar?',
    nextNodeId: '',
    options: [
      { id: '1', label: 'Vendas', action: 'goto', targetId: 'vendas' },
      { id: '2', label: 'Suporte', action: 'goto', targetId: 'suporte' },
      { id: '3', label: 'Falar com atendente', action: 'handoff', targetId: '' }
    ]
  }
}

export function renderMenuPreview(step) {
  if (!step || step.type !== 'menu') {
    return step?.text || ''
  }
  let out = step.text || ''
  for (const o of step.options || []) {
    out += `\n${o.id} - ${o.label}`
  }
  out += '\n\nDigite o número da opção desejada.'
  return out
}
